import { render } from "./ICheckInput.vue?vue&type=template&id=6daec6ca"
import script from "./ICheckInput.vue?vue&type=script&lang=js"
export * from "./ICheckInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__